export default __webpack_public_path__ + "static/media/666.4663f8eb.svga";